import React, { useEffect, useState } from "react";
import HeatMapPageStyle from "./heatmap.module.css";
import { Button, Form, Input, Radio, Upload, Select, Row, Col } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import ColorList from "./color";
import http from "../../../utils/http";
const { TextArea } = Input;
const { Option } = Select;
function HeatMapPage() {
  const [form] = Form.useForm();
  const [fileContent, setFileContent] = useState("");
  const [HeatValue, setHeatValue] = useState(1);
  const [selectedColors, setSelectedColors] = useState([]); // 用于保存选中的颜色
  const [ColorOptions, setColorOptions] = useState([]);
  const [imgUrl, setImgUrl] = useState("");
  useEffect(() => {
    console.log(ColorList);
    let TempleArr = [];
    Object.keys(ColorList).forEach((key) => {
      TempleArr.push({
        label: (
          <p>
            <span>{key}</span>{" "}
            <span style={{ color: "#ccc" }}>{ColorList[key]}</span>
          </p>
        ),
        value: key,
      });
    });
    setColorOptions(TempleArr);
  }, []);
  const onFinish = (values) => {
    console.log("Success:", values);
    const newFormData = new FormData();
    const TempleArr = {
      file: values.SN === undefined ? values.gene_id_text : values.SN.file,
      data: values.gene_id_text,
      Value: values.value,
      color: values.color,
    };
    Object.keys(TempleArr).forEach((key) => {
      newFormData.append(key, TempleArr[key]);
    });
    http
      .post("/api/tools/heatmap/", newFormData)
      .then((res) => {
        setImgUrl(res.image);
      })
      .catch((err) => {});
  };

  const contentUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target.result;
      setFileContent(content);
      console.log(content);
    };
    reader.readAsText(file);
    return false; // 阻止默认上传行为
  };

  useEffect(() => {
    form.setFieldsValue({
      gene_id_text: fileContent,
    }); // 初始化时更新文本域的值
  }, [fileContent]);

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setHeatValue(e.target.value);
  };
  // // 处理颜色选择变化
  // const onColorChange = (checkedValues) => {
  //   if (checkedValues.length > 2) {
  //     // 如果选中了超过两个颜色，移除最后一个
  //     checkedValues.shift();
  //   }
  //   setSelectedColors(checkedValues);
  // };
  // const renderColorBlocks = (color) => {
  //   return (
  //     <span
  //       style={{
  //         backgroundColor: color,
  //         width: 15,
  //         height: 15,
  //         display: "inline-block",
  //         marginLeft: 10,
  //         borderRadius: "50%",
  //       }}
  //     ></span>
  //   );
  // };

  const onChangeColor = (value) => {
    console.log(`selected ${value}`);
  };
  const onSearchColor = (value) => {
    console.log("search:", value);
  };
  return (
    <div className={HeatMapPageStyle.HeatMapPage_app}>
      <div className={HeatMapPageStyle.HeatMapPage_Header}>
        <p>HeatMap</p>
      </div>
      <div className={HeatMapPageStyle.HeatMapPage_FormDiv}>
        {/* <div className={HeatMapPageStyle.HeatMapPage_FormDiv_header}>
          <p>Heatmap</p>
        </div> */}
        <Form
          form={form}
          onFinish={onFinish}
          style={{ width: "60%", margin: "20px auto" }}
          initialValues={{ color: "viridis", value: "TPM" }}
        >
          <Form.Item
            name="gene_id_text"
            label={<span style={{ fontWeight: "bold" }}>Genome file</span>}
          >
            <TextArea style={{ height: 150 }} />
          </Form.Item>
          <Row>
            <Col span={12}>
              <Form.Item
                colon={false}
                label={
                  <span style={{ color: "transparent" }}>41565465465</span>
                }
                name="SN"
                style={{ width: "60%" }}
              >
                <Upload
                  beforeUpload={contentUpload}
                  name="SN"
                  action="/upload.do"
                  onRemove={() => setFileContent("")}
                >
                  <Button
                    style={{
                      border: "none",
                      padding: "0",
                      margin: "0",
                      background: "transparent",
                    }}
                    icon={<UploadOutlined />}
                  >
                    Click to upload
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item>
                <Button
                  style={{
                    color: "#67C23A",
                    border: "none",
                    fontWeight: "bold",
                    background: "transparent",
                    boxShadow: "none",
                  }}
                  onClick={() => {
                    form.setFieldsValue({
                      gene_id_text: `group	A	A	A	B	B	B	C	C
sample	A-1	A-2	A-3	B-1	B-2	B-3	C-1	C-2
G1	5.7	11.7	9.9	5.7	4.5	3.2	8.7	12.3
G2	9.43	10.67	9.39	3.4	2.5	2.3	7.8	10.1
G3	10.59	9.89	8.5	4.2	5.75	2.5	6.3	8.9
G4	10.38	10.2	8.5	5.1	2.8	2.4	7.7	9.5
G5	5.75	10.85	10.9	3.9	4.2	2.8	7.4	8.6
G6	9.82	10.45	8.5	2.5	3.4	3.5	6.1	9.3
G7	8.9	11.02	10.33	5.75	2.4	5.75	7.2	11.0
G8	10.59	10.67	9.94	6.55	5.75	5.55	9.2	10.3
G9	2.5	5.2	3.5	9.21	9.76	11.47	7.1	6.4
G10	3.5	4.2	2.5	9.21	11.78	5.75	7.5	6.3
G11	4.5	3.2	2.7	9.89	10.72	8.81	6.7	8.0
G12	3.5	2.2	1.9	10.85	9.76	9.73	7.8	8.3
G13	3.5	4.2	3.5	11.33	9.76	10.49	8.5	9.9
G14	5.1	1.2	5.75	11.22	9.76	8.81	7.3	8.7`,
                    });
                  }}
                >
                  example
                </Button>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label={<span style={{ fontWeight: "bold" }}>Value</span>}
            name="value"
          >
            <Radio.Group onChange={onChange} value={HeatValue}>
              <Radio value="TPM">TPM</Radio>
              <Radio value="log2(TPM+1)">log2(TPM+1)</Radio>
              <Radio value="log10(TPM+1)">log10(TPM+1)</Radio>
            </Radio.Group>
          </Form.Item>

          {/* <Form.Item
            label={<span style={{ fontWeight: "bold" }}>Color</span>}
            name="color"
          >
            <Checkbox.Group
              value={selectedColors}
              onChange={onColorChange}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Checkbox value="#FF0000">
                Red {renderColorBlocks("#FF0000")}
              </Checkbox>
              <Checkbox value="#00FF00">
                Green {renderColorBlocks("#00FF00")}
              </Checkbox>
              <Checkbox value="#4b4bfc">
                Blue {renderColorBlocks("#4b4bfc")}
              </Checkbox>
              <Checkbox value="#FFFF00">
                Yellow {renderColorBlocks("#FFFF00")}
              </Checkbox>
              <Checkbox value="#FF00FF">
                Magenta {renderColorBlocks("#FF00FF")}
              </Checkbox>
              <Checkbox value="#00FFFF">
                Cyan {renderColorBlocks("#00FFFF")}
              </Checkbox>
            </Checkbox.Group>
            <div style={{ marginTop: "10px" }}>
              <span style={{ fontSize: "12px", color: "#888" }}>
                * You can select up to two colors.
              </span>
            </div>
          </Form.Item> */}
          <Form.Item
            name="color"
            label={<span style={{ fontWeight: "bold" }}>Color</span>}
            tooltip={
              <div>
                <p>
                  <span style={{ padding: "0 5px" }}>Blues</span>
                  <span style={{ padding: "0 5px" }}>从白色到深蓝色的渐变</span>
                </p>
              </div>
            }
          >
            <Select
              showSearch
              placeholder="Select a person"
              optionFilterProp="label"
              onChange={onChangeColor}
              onSearch={onSearchColor}
              options={ColorOptions}
              // options={[
              //   {
              //     label: <span style={{color:"Red"}}>444</span>,
              //   }
              // ]}
            />
          </Form.Item>
          <Form.Item
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              style={{
                margin: "0 10px",
                background: "#67C23A",
                border: "none",
                color: "white",
              }}
            >
              Submit
            </Button>
            <Button
              style={{ border: "1px solid #6C5E6E", color: "#6C5E6E" }}
              onClick={() => {
                form.resetFields();
                setSelectedColors([]);
                setImgUrl("");
              }}
            >
              Reset
            </Button>
          </Form.Item>
        </Form>
        {imgUrl && (
          <div
            style={{
              textAlign: "center",
              marginTop: "20px",
              opacity: imgUrl ? 1 : 0,
              transition: "opacity 0.3s ease-in-out", // 添加过渡效果
            }}
          >
            <h3>HeatMap Image</h3>
            <img
              src={`data:image/png;base64,${imgUrl}`}
              alt="Heatmap"
              style={{ width: "80%", maxWidth: "600px", borderRadius: "8px" }}
            />
          </div>
        )}
        <div style={{ width: "100%", height: "5vh" }}></div>
      </div>
    </div>
  );
}

export default HeatMapPage;
